















import {
  AccountingIntegrationSettings,
  SyncServiceType,
} from '@accounting-integrations/interfaces/accounting-integrations';
import ExactAuthLink from '@shared/components/forms/inputs/exact-auth-link/exact-auth-link.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

interface ExactParams {
  client_id: string;
  redirect_uri: string;
  auth_url: string;
}

@Component({
  name: 'bpc-invoice-sync-setting-form',
  components: {
    ExactAuthLink,
  },
})
export default class InvoiceSyncSettingForm extends Vue {
  @Prop({ type: String }) readonly uxSessionCode: string;

  loading: boolean = true;
  exactParams: ExactParams = {
    client_id: null,
    redirect_uri: null,
    auth_url: null,
  };

  get accountingIntegrationSettings(): AccountingIntegrationSettings {
    if (this.$modulesService.hasModuleActivated('accounting_integrations')) {
      return this.$store.getters['centerSettings/accountingIntegrationSettings'];
    }

    return null;
  }

  get syncServiceType(): SyncServiceType {
    return this.accountingIntegrationSettings?.sync_service_type;
  }

  get syncServiceName(): string {
    return this.accountingIntegrationSettings.sync_service;
  }

  get exactParamsReady(): boolean {
    if (this.syncServiceName !== 'exact') {
      return false;
    }

    if (this.loading) {
      return false;
    }

    return !!(
      this.exactParams?.client_id &&
      this.exactParams?.redirect_uri &&
      this.exactParams?.auth_url
    );
  }

  mounted() {
    this.loading = true;
    this.getFormConfig();
  }

  async getFormConfig() {
    if (this.syncServiceName === 'exact') {
      console.log('Getting Exact config fields');
      const res = await this.$bpcConfig
        .getEntityConfig('center_setting.forms.default.fields')
        .toPromise();
      const fields = res?.data;
      console.log('Exact config fields:', fields);

      this.exactParams = fields?.exact_integration_link?.exactParams;
    }

    this.loading = false;
  }

  redirectToCenterSettings() {
    this.$router.push({
      name: 'admin-center-settings',
    });
  }
}
